module.exports = require("./fr-CF.js");